module.exports = __webpack_public_path__ + "img/QOOKER_Box11.dd4792b6.jpg";